module.exports = __webpack_public_path__ + "img/leaf.14490542.svg";